<template>
  <div class="flex flex-wrap gap-2 mb-4">
    <span class="text-sm text-gray-600 mr-2">{{ $t("reports.filters.quick_dates") }}:</span>
    <Button
      :class="[
        'text-xs px-3 py-1 rounded-md transition-colors',
        selectedPreset === 'today' 
          ? 'bg-primary-500 text-white' 
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
      ]"
      @click="selectPreset('today')"
      :label="$t('reports.filters.presets.today')"
    />
    <Button
      :class="[
        'text-xs px-3 py-1 rounded-md transition-colors',
        selectedPreset === 'yesterday' 
          ? 'bg-primary-500 text-white' 
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
      ]"
      @click="selectPreset('yesterday')"
      :label="$t('reports.filters.presets.yesterday')"
    />
  </div>
</template>

<script>
import { Button } from 'primevue';

export default {
  name: 'FilterSingleDayQuickDates',
  components: {
    Button
  },
  props: {
    modelValue: {
      type: String,
      default: 'today'
    }
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      selectedPreset: this.modelValue || 'today'
    };
  },
  methods: {
    selectPreset(presetKey) {
      this.selectedPreset = presetKey;
      this.$emit('update:modelValue', presetKey);
      this.$emit('change', presetKey);
    }
  },
  watch: {
    modelValue(newValue) {
      this.selectedPreset = newValue;
    }
  }
};
</script>

